import { useHistory } from '@/utils/bhooks'
import {
  defineComponent,
  getCurrentInstance,
  ref,
  watch
} from '@vue/composition-api'
const Layout = defineComponent({
  name: 'Layout',
  setup() {
    return () => {
      //NewCreateResearch
      return (
        // <keep-alive>
        //   <router-view />
        // </keep-alive>
        <router-view />
      )
    }
  }
})

export default Layout
